<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/priceControlList' }">价格控制</el-breadcrumb-item>
                <el-breadcrumb-item>价格控制{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                        <el-form-item label="开始时间：" prop="start_date">
                            <el-date-picker
                                v-model="ruleForm.start_date"
                                type="date"
                                placeholder="请选择开始时间"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                @change="startChange"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：" prop="end_date">
                            <el-date-picker
                                v-model="ruleForm.end_date"
                                type="date"
                                placeholder="请选择结束时间"
                                format="yyyy-MM-dd"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                @change="endDate"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="code：" prop="code">
                            <el-input v-model="ruleForm.code" size="mini" placeholder="请输入代码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：" prop="approval_status_label" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.approval_status_label"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="产品：" prop="product_name">
                            <el-select
                                v-model="ruleForm.product_name"
                                placeholder="请选择产品"
                                clearable
                                filterable
                                size="mini"
                                @change="productChange"
                                :disabled="changeDisable"
                            >
                                <el-option v-for="item in productOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时效性：" prop="timeliness" v-if="type == 1">
                            <el-input v-model="ruleForm.timeliness_label" size="mini" class="flex_item_text" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="单位底价上限：" prop="unit_base_price_upper_bound">
                            <el-input
                                v-model="ruleForm.unit_base_price_ub"
                                size="mini"
                                placeholder="请输入单位底价上限"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="优先：" prop="priority">
                            <el-select
                                v-model="ruleForm.priority_label"
                                placeholder="请选择优先"
                                clearable
                                size="mini"
                                @change="priorityChange"
                            >
                                <el-option v-for="item in priorityOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省份：" prop="province_name">
                            <el-select
                                v-model="ruleForm.province_name"
                                placeholder="请选择省份"
                                clearable
                                @change="provinceChange"
                                filterable
                                size="mini"
                            >
                                <el-option v-for="item in provincesOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单位底价下限：" prop="unit_base_price_lb" v-if="type != 1">
                            <el-input
                                v-model="ruleForm.unit_base_price_lb"
                                size="mini"
                                placeholder="请输入单位底价下限"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="城市：" prop="city_name">
                            <el-select
                                v-model="ruleForm.city_name"
                                placeholder="请选择城市"
                                clearable
                                filterable
                                size="mini"
                                @change="cityChange"
                            >
                                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否包含本数：" prop="unit_base_price_lb_exclusive" v-if="type != 1">
                            <div style="width: 280px">
                                <el-switch v-model="unit_lb_checked" active-color="#13ce66" inactive-color="#cccccc" @change="priceLb">
                                </el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item label="合作方：" prop="partner_name">
                            <el-select
                                v-model="ruleForm.partner_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入合作方搜索"
                                :remote-method="remotePartner"
                                :loading="partnerLoading"
                                size="mini"
                                clearable
                                @change="partnerChange"
                            >
                                <el-option v-for="item in partnerOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="职位等级：" prop="rank" v-if="type != 1">
                            <el-select
                                size="mini"
                                v-model="ruleForm.rank"
                                placeholder="请选择职位等级"
                                clearable
                                style="width: 100%"
                                filterable
                            >
                                <el-option v-for="item in rankOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="上次提交人职位：" prop="submission_hierarchy_name" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.submission_hierarchy_name"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="提交人职位：" prop="submission_hierarchy_rid">
                            <el-select
                                size="mini"
                                v-model="ruleForm.submission_hierarchy_rid"
                                placeholder="请选择提交人职位"
                                clearable
                                style="width: 100%"
                                filterable
                            >
                                <el-option v-for="item in hierarchyOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="级别：" prop="level" v-if="type == 1">
                            <el-input v-model="ruleForm.level_label" size="mini" class="flex_item_text" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="其他信息" name="3" v-if="type == 1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                        <el-form-item label="特征码：" prop="feature_code" v-if="type == 1">
                            <el-input v-model="ruleForm.feature_code" size="mini" class="flex_item_text" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：" prop="MEPR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.marginal_expense_provision_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="VATR：" prop="VATR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.value_added_tax_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="单位底价信息" name="2" v-if="type == 1">
                    <el-table :data="data" border>
                        <el-table-column prop="unit_base_price_lb_exclusive" label="单位底价下限" width="120"> </el-table-column>
                        <el-table-column prop="unit_base_price_lb_exclusive_label" label="是否包含本数" width="120"> </el-table-column>
                        <el-table-column prop="hierarchy_name" label="层级名称" width="320"> </el-table-column>
                        <el-table-column prop="include_superior_label" label="是否包含上级" width="120"> </el-table-column>
                        <el-table-column prop="standard_price_conversion_factor" label="SR折算系数" width="120">
                            <template slot-scope="scope">
                                <span
                                    :class="{
                                        excellent: scope.row.standard_price_conversion_factor >= 0.9,
                                        good:
                                            scope.row.standard_price_conversion_factor >= 0.82 &&
                                            scope.row.standard_price_conversion_factor < 0.9,
                                        common:
                                            scope.row.standard_price_conversion_factor >= 0.54 &&
                                            scope.row.standard_price_conversion_factor < 0.82,
                                        remind:
                                            scope.row.standard_price_conversion_factor >= 0.24 &&
                                            scope.row.standard_price_conversion_factor < 0.54,
                                        warn: scope.row.standard_price_conversion_factor < 0.24
                                    }"
                                >
                                    {{ scope.row.standard_price_conversion_factor }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'priceControlEdit',
    data() {
        return {
            btnLoading: false,
            data: [],
            partnerLoading: false,
            rid: '',
            rankOptions: [],
            hierarchyOptions: [],
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1', '2'],
            labelPosition: 'right',
            unit_ub_checked: true,
            unit_lb_checked: true,
            //基本信息内表单验证
            ruleForm: {
                code: '',
                product_rid: '',
                province_rid: '',
                city_rid: '',
                level_label: '',
                product_name: '',
                province_name: '',
                city_name: '',
                partner_rid: '',
                partner_name: '',
                start_date: '',
                priority_label: '通用',
                end_date: '',
                unit_base_price_ub: '',
                unit_base_price_lb: '',
                unit_base_price_ub_exclusive: '',
                unit_base_price_lb_exclusive: '',
                priority: '1',
                created_at: '',
                created_by: '',
                timeliness_label: '',
                updated_at: '',
                updated_by: '',
                approval_status_label: '',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                submission_hierarchy_rid: ''
            },
            typeUb: '1',
            typeLb: '1',
            rules: {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                product_name: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                start_date: [{ required: true, message: '请输入开始时间', trigger: 'blur' }],
                end_date: [{ required: true, message: '请输入结束时间', trigger: 'blur' }],
                priority: [{ required: true, message: '请选择优先', trigger: 'blur' }],
                unit_base_price_lb: [{ required: true, message: '请输入单位底价下限', trigger: 'blur' }],
                rank: [{ required: true, message: '请选择职位等级', trigger: 'blur' }],
                submission_hierarchy_rid: [{ required: true, message: '请选择提交人职位', trigger: 'blur' }]
            },
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            productOptions: [], //产品列表
            partnerOptions: [], //合作方列表
            states: [],
            //优先列表
            priorityOptions: [
                {
                    value: '1',
                    label: '通用'
                },
                {
                    value: '2',
                    label: '专项'
                }
            ],
            levelOptions: [
                //级别列表
                {
                    value: '1',
                    label: '全国'
                },
                {
                    value: '2',
                    label: '省'
                },
                {
                    value: '3',
                    label: '市'
                },
                {
                    value: '4',
                    label: '合作方'
                },
                {
                    value: '5',
                    label: '省级合作方'
                },
                {
                    value: '6',
                    label: '市级合作方'
                }
            ],
            //时效性列表
            timelinessOptions: [
                {
                    value: '1',
                    label: '效期前'
                },
                {
                    value: '2',
                    label: '效期中'
                },
                {
                    value: '3',
                    label: '效期后'
                }
            ],
            btnTitle: '',
            changeDisable: false
        };
    },
    watch: {
        $route(to, from) {
            this.type = to.query.type;
            this.rid = to.query.id;
            if (to.query.type) {
                if (to.query.type == 1) {
                    this.getProvinces(); //获取省份
                    this.getRank(); //获取上级
                    this.getDetails();
                } else if (to.query.type == 5) {
                    this.getProvinces(); //获取省份
                    this.getRank(); //获取上级
                    this.getDetails();
                } else {
                    this.ruleForm = {
                        code: '',
                        product_rid: '',
                        province_rid: '',
                        city_rid: '',
                        level_label: '',
                        product_name: '',
                        province_name: '',
                        city_name: '',
                        partner_rid: '',
                        partner_name: '',
                        start_date: '',
                        priority_label: '通用',
                        end_date: '',
                        unit_base_price_ub: '',
                        unit_base_price_lb: '',
                        unit_base_price_ub_exclusive: '',
                        unit_base_price_lb_exclusive: '',
                        priority: '1',
                        created_at: '',
                        created_by: '',
                        timeliness_label: '',
                        updated_at: '',
                        updated_by: '',
                        approval_status_label: '',
                        marginal_expense_provision_rate: '',
                        value_added_tax_rate: '',
                        submission_hierarchy_rid: ''
                    };
                    if (this.type == 4) {
                        this.ruleForm.product_rid = to.query.id;
                        this.ruleForm.product_name = to.query.name;
                        this.changeDisable = true;
                    }
                }
            }
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    mounted() {
        this.getProduct(); //获取产品
        this.getProvinces(); //获取省份
        this.getRank(); //获取上级
        // this.getHierarchies();
        if (this.type == 1) {
            this.getDetails(); //获取详情
        } else if (this.type == 5) {
            this.getDetails();
        } else {
            this.ruleForm = {
                code: '',
                product_rid: '',
                province_rid: '',
                city_rid: '',
                level_label: '',
                product_name: '',
                province_name: '',
                city_name: '',
                partner_rid: '',
                partner_name: '',
                start_date: '',
                priority_label: '通用',
                end_date: '',
                unit_base_price_ub: '',
                unit_base_price_lb: '',
                unit_base_price_ub_exclusive: '',
                unit_base_price_lb_exclusive: '',
                priority: '1',
                created_at: '',
                created_by: '',
                timeliness_label: '',
                updated_at: '',
                updated_by: '',
                approval_status_label: '',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                submission_hierarchy_rid: ''
            };
            if (this.type == 4) {
                this.ruleForm.product_rid = this.$route.query.id;
                this.ruleForm.product_name = this.$route.query.name;
                this.changeDisable = true;
            }
        }
    },
    methods: {
        //获取提交人职位
        // getHierarchies() {
        //     let params = {};
        //     this.$api
        //         .adminHierarchies(params)
        //         .then((res) => {
        //             if (res.code == 0) {
        //                 this.hierarchyOptions = res.data;
        //                 if (res.data.length != 0) {
        //                     this.ruleForm.submission_hierarchy_rid = res.data[0].value;
        //                 }
        //             }
        //         })
        //         .catch((error) => {
                    
        //         });
        // },
        //获取职位等级
        getRank() {
            let params = {};
            this.$api
                .decisionRank(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.rankOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.rankOptions.push({
                                value: value.value,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //开始时间框联动
        startChange(val) {
            this.ruleForm.start_date = val;
            this.ruleForm.end_date = '';
        },
        //结束时间框联动
        endDate(val) {
            if (val) {
                if (!this.ruleForm.start_date) {
                    this.$message({
                        message: '请先选择开始时间！',
                        type: 'warning'
                    });
                    this.ruleForm.end_date = '';
                } else {
                    let startTime = this.ruleForm.start_date.replace(/-/g, '');
                    let endTime = this.ruleForm.end_date.replace(/-/g, '');
                    if (endTime < startTime) {
                        this.$message({
                            message: '结束时间不能小于开始时间！',
                            type: 'warning'
                        });
                        this.ruleForm.end_date = '';
                    }
                }
            }
        },
        //合作方选择框联动
        partnerChange(val) {
            this.ruleForm.partner_rid = val;
        },
        //优先选择框联动
        priorityChange(val) {
            this.ruleForm.priority = val;
        },
        //级别选择框联动
        levleChange(val) {
            this.ruleForm.level = val;
        },
        //产品选择框联动
        productChange(val) {
            this.ruleForm.product_rid = val;
        },
        //城市选择框联动
        cityChange(val) {
            this.ruleForm.city_rid = val;
            this.ruleForm.city_name = val;
        },
        //是否包含本数
        priceLb(value) {
            if (value) {
                this.typeLb = '1';
            } else {
                this.typeLb = '2';
            }
        },
        //合作方搜索
        remotePartner(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.partnerLoading = false;
                                this.partnerOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.provincesOptions = data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //省份改变请求当下省份下的城市
        provinceChange(val) {
            this.cityOptions = [];
            this.ruleForm.province_rid = val;
            if (val) {
                this.ruleForm.city_name = '';
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.ruleForm.city_name = '';
                this.cityOptions = [];
            }
        },
        //编辑时获取当前省份下的城市
        getCityOptions(val) {
            if (val) {
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.cityOptions = [];
            }
        },
        //获取产品
        getProduct() {
            let params = {
                has_all: '0'
            };
            this.$api
                .dropdownProducts(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.productOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/priceControlList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .priceControlDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = {
                            marginal_expense_provision_rate: res.data.marginal_expense_provision_rate,
                            value_added_tax_rate: res.data.value_added_tax_rate,
                            approval_status_label: res.data.approval_status_label,
                            code: res.data.code,
                            product_rid: res.data.product_rid,
                            province_rid: res.data.province_rid,
                            city_rid: res.data.city_rid,
                            product_name: res.data.product_name,
                            province_name: res.data.province_name,
                            city_name: res.data.city_name,
                            partner_rid: res.data.partner_rid,
                            partner_name: res.data.partner_name,
                            rank: res.data.hierarchies[0].decision_rank,
                            level_label: res.data.level_label,
                            start_date: res.data.start_date,
                            end_date: res.data.end_date,
                            priority_label: res.data.priority_label,
                            unit_base_price_ub: res.data.unit_base_price_ub,
                            unit_base_price_lb: res.data.unit_base_price_lb,
                            unit_base_price_ub_exclusive: res.data.unit_base_price_ub_exclusive,
                            unit_base_price_lb_exclusive: res.data.unit_base_price_lb_exclusive,
                            priority: res.data.priority,
                            created_at: res.data.created_at,
                            created_by: res.data.created_by,
                            updated_at: res.data.updated_at,
                            updated_by: res.data.updated_by,
                            timeliness_label: res.data.timeliness_label,
                            submission_hierarchy_rid: res.data.submission_hierarchy_rid
                        };
                        if (res.data.unit_base_price_ub_exclusive == 1) {
                            this.unit_ub_checked = true;
                        } else {
                            this.unit_ub_checked = false;
                        }
                        if (res.data.unit_base_price_lb_exclusive == 1) {
                            this.unit_lb_checked = true;
                        } else {
                            this.unit_lb_checked = false;
                        }
                        this.data = res.data.hierarchies;
                        if (res.data.province_rid) {
                            this.getCityOptions(res.data.province_rid);
                        }
                        this.typeUb = res.data.unit_base_price_ub_exclusive;
                        this.typeLb = res.data.unit_base_price_lb_exclusive;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                code: this.ruleForm.code,
                product_rid: this.ruleForm.product_rid,
                province_rid: this.ruleForm.province_rid ? this.ruleForm.province_rid : '',
                city_rid: this.ruleForm.city_rid ? this.ruleForm.city_rid : '',
                partner_rid: this.ruleForm.partner_rid ? this.ruleForm.partner_rid : '',
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                unit_base_price_ub: this.ruleForm.unit_base_price_ub ? this.ruleForm.unit_base_price_ub : '',
                unit_base_price_lb: this.ruleForm.unit_base_price_lb ? this.ruleForm.unit_base_price_lb : '',
                unit_base_price_ub_exclusive: this.typeUb,
                unit_base_price_lb_exclusive: this.typeLb,
                priority: this.ruleForm.priority ? this.ruleForm.priority : '1',
                rid: this.rid,
                decision_rank: this.ruleForm.rank,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .priceControlUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                code: this.ruleForm.code,
                product_rid: this.ruleForm.product_rid,
                province_rid: this.ruleForm.province_rid ? this.ruleForm.province_rid : '',
                city_rid: this.ruleForm.city_rid ? this.ruleForm.city_rid : '',
                partner_rid: this.ruleForm.partner_rid ? this.ruleForm.partner_rid : '',
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                unit_base_price_ub: this.ruleForm.unit_base_price_ub ? this.ruleForm.unit_base_price_ub : '',
                unit_base_price_lb: this.ruleForm.unit_base_price_lb ? this.ruleForm.unit_base_price_lb : '',
                unit_base_price_ub_exclusive: this.typeUb,
                unit_base_price_lb_exclusive: this.typeLb,
                priority: this.ruleForm.priority ? this.ruleForm.priority : '1',
                decision_rank: this.ruleForm.rank,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .priceControlInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        }
    }
};
</script>